import _cloneDeep from 'lodash/cloneDeep';

export function cloneCampusInfo(campus) {
  return _cloneDeep(campus);
}
